module.exports = __webpack_public_path__ + "img/navTitle.d29244df.png";